function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import moment from 'moment';
import { LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
import { jsx as ___EmotionJSX } from "@emotion/core";
var homepassIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/homepass-logo-blue_62759e9e.png";
var validateMobileNumber = number => {
  var noSpaces = number.replace(' ', '');
  if (noSpaces.startsWith('04') && noSpaces.length === 10) {
    return "+61".concat(noSpaces.substring(1));
  }
  if (noSpaces.startsWith('+61') && noSpaces.length === 12) {
    return noSpaces;
  }
  return null;
};
var useHomepass = props => {
  var baseClass = 'allhomes-listing-details';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    homepassModalOpen = _useState2[0],
    setHomepassModalOpen = _useState2[1];
  var onBookInspectionClick = () => {
    setHomepassModalOpen(true);
  };
  var closeHomepassModal = () => setHomepassModalOpen(false);
  var submitHomepassBooking = _ref => {
    var attendee = _ref.attendee,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
    var endpoint = "".concat(props.homepassEndpoint, "/").concat(props.property.listing.id, "/book");
    var requestData = {
      email: attendee.email,
      name: attendee.name,
      mobile: validateMobileNumber(attendee.mobile),
      postcode: attendee.postcode,
      preferredStartDateTime: moment(startDate).toISOString(true),
      preferredEndDateTime: moment(endDate).toISOString(true)
    };
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    }).then(response => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Unable to book inspection'));
      }
      return Promise.resolve();
    });
  };
  var homepassPrivacyCopy = ___EmotionJSX("p", null, "We collect personal data such as your contact and demographic information to share with our partners (such as this specific real estate agent and other relevant service providers) & providing personalised content. For full details please refer to our", ' ', ___EmotionJSX("a", {
    href: props.privacyUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "".concat(baseClass, "__homepass-privacy-link")
  }, "Privacy Policy"));
  var homepassFormLogos = ___EmotionJSX("div", {
    className: "".concat(baseClass, "__homepass-booking-logo-container")
  }, ___EmotionJSX(LinkButton, {
    appearance: "ghost",
    className: "".concat(baseClass, "__homepass-booking-allhomes-logo-link"),
    href: "https://www.allhomes.com.au/"
  }, ___EmotionJSX(AllhomesLogo, null)), ___EmotionJSX("img", {
    className: "".concat(baseClass, "__homepass-booking-homepass-logo"),
    alt: "Homepass logo",
    src: homepassIcon
  }));
  return {
    homepassModalOpen,
    closeHomepassModal,
    submitHomepassBooking,
    onBookInspectionClick,
    listingAddress: "".concat(props.property.address.line1, ", ").concat(props.property.address.division.name),
    privacyUrl: props.privacyUrl,
    termsUrl: props.termsUrl,
    privacyCopy: homepassPrivacyCopy,
    customLogos: homepassFormLogos
  };
};
export default useHomepass;